/// <reference no-default-lib="true"/>
/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { IconButton } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import useDebounce from "./useDebounce";
// import SwapVertIcon from '@mui/icons-material/SwapVert';

interface ConfigLista {
  nextPage: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  totalItems: number;
}

interface Paginacao {
  lista: any[];
  configLista: ConfigLista;
  page: number;
  perPage: number;
  setPage: (page: number) => void;
  setPerPage: (perPage: number) => void;
  setOrder: (order: "ASC" | "DESC") => void;
  FerramentaNavegacaoExportacao?: boolean;
  urlLista?: string;
}

export default function Paginacao(props: Paginacao) {
  const [value, setValue] = useState<string>('');
  const debouncedValue = useDebounce(value, 3000);
  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get("page"));

  // 💡 Desestruturando para simplificar
  const { lista, configLista, setOrder } = props;
  const { totalItems, hasNextPage, hasPreviousPage } = configLista;

  const itensPorPagina = lista.length || 0;
  const inicio = totalItems === 0 ? 0 : (Number(page) - 1) * itensPorPagina + 1;
  const fim = Math.min(Number(page) * itensPorPagina, totalItems);

  // CONTROLAR SE EXISTE PAGINA NA URL, PARA CASOS EM QUE NAO SE PASSOU O PARAMETRO PAGINA
  useEffect(() => {
    if (page === null) {
      const params = new URLSearchParams(searchParams);
      params.set("page", '1');
      setSearchParams(params);
      setPage('1');
    } 
    // else {
    //   props.setPage(Number(page));
    // }
  }, [page]);

  useEffect(() => {
    if (debouncedValue) {
      // props.setPerPage(Number(debouncedValue));
      props.setPerPage(Number(debouncedValue ?? 0));
    }

    localStorage.setItem("page", JSON.stringify(props.page));
  }, [debouncedValue, props]);

  const handleChangePageNext = () => {
    const params = new URLSearchParams(searchParams);
    params.set("page", JSON.stringify(props.configLista.nextPage));
    localStorage.setItem("page", JSON.stringify(props.configLista.nextPage));

    setSearchParams(params);

    // props.setPage(props.configLista.nextPage);
    props.setPage(Number(props.configLista.nextPage ?? 1));
  };

  const handleChangePagePreviou = () => {
    const params = new URLSearchParams(searchParams);
    params.set("page", JSON.stringify(props.configLista.nextPage - 2));
    localStorage.setItem("page", JSON.stringify(props.configLista.nextPage - 2));
    setSearchParams(params);

    // props.setPage(props.configLista.nextPage - 2);
    props.setPage(Number(props.configLista.nextPage ?? -2));

  };

  return (
    lista?.length > 0 ?
      <div style={{ padding: 20, display: 'flex' }}>
        <div style={{ flexGrow: 1 }}>

            Exibindo <strong>{inicio}</strong>–<strong>{fim}</strong> de
            <strong>
              <IconButton
                title="Clique para exibir todos os itens"
                disabled={!hasNextPage}
                onClick={() => props.setPerPage(totalItems)}
              >
                {totalItems}
              </IconButton>
            </strong>
            no total

            {/* <IconButton
              title="Clique para inverter a ordem de exibição dos itens (RECENTES/ANTIGOS)"
              // onClick={setOrder.bind(null, "DESC")}
              // onClick={() => setOrder(order => order === "ASC" ? "DESC" : "ASC")}
              aria-label=""
            >
              <SwapVertIcon /> 
            </IconButton> */}

          <input
            style={{ padding: 3, width: 170, margin: 5, borderRadius:7 }}
            placeholder='Quantidade por página'
            defaultValue={props.perPage}
            type="number"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value)}
          />
        </div>

        <div>
          Pagina: {props.page}

          <IconButton component="button" disabled={!props?.configLista?.hasPreviousPage} type="submit" onClick={handleChangePagePreviou}>
            <NavigateBeforeIcon />
          </IconButton>

          <IconButton component="button" disabled={!props?.configLista?.hasNextPage} type="submit" onClick={handleChangePageNext}>
            <NavigateNextIcon />
          </IconButton>
        </div>
      </div>
      :
      <></>
  );
}